module.exports = __webpack_public_path__ + "img/btn__arrow__white.eab66994.svg";